module.exports = __webpack_public_path__ + "static/media/about-img.bdfb5a6e.png";